import React from "react";
import {
  AppBar,
  Toolbar,
  IconButton,
  //Typography,
  Button,
  Stack,
  Menu,
  MenuItem,
  Divider,
} from "@mui/material";
import CatchingPokemonIcon from "@mui/icons-material/CatchingPokemon";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import MuiListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import { styled, alpha } from "@mui/material/styles";
//import Tabs from '@mui/material/Tabs';
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import { NavLink } from "react-router-dom";
import "../assets/css/HeaderMenu.scss";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import LogoutIcon from "@mui/icons-material/Logout";
import PasswordIcon from "@mui/icons-material/Password";
//import EditIcon from "@mui/icons-material/Edit";
//import ArchiveIcon from "@mui/icons-material/Archive";
//import FileCopyIcon from "@mui/icons-material/FileCopy";
//import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { useDispatch } from "react-redux";
import sktrDetailsSlice from "../redux/sktrSlice";

const ListItemButton = styled(MuiListItemButton)({
  "&.active .MuiTypography-root": {
    fontWeight: "bold",
  },
});
const StyledMenu = styled((props) => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: "bottom",
      horizontal: "right",
    }}
    transformOrigin={{
      vertical: "top",
      horizontal: "right",
    }}
    {...props}
  />
))(({ theme }) => ({
  "& .MuiPaper-root": {
    borderRadius: 6,
    marginTop: theme.spacing(1),
    minWidth: 180,
    color:
      theme.palette.mode === "light"
        ? "rgb(55, 65, 81)"
        : theme.palette.grey[300],
    boxShadow:
      "rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px",
    "& .MuiMenu-list": {
      padding: "4px 0",
    },
    "& .MuiMenuItem-root": {
      "& .MuiSvgIcon-root": {
        fontSize: 18,
        color: theme.palette.text.secondary,
        marginRight: theme.spacing(1.5),
      },
      "&:active": {
        backgroundColor: alpha(
          theme.palette.primary.main,
          theme.palette.action.selectedOpacity
        ),
      },
    },
  },
}));

export default function HeaderMenu(props) {
  const [value, setValue] = React.useState(0);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const dispatch = useDispatch();
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  //Header Nav paths
  const paths = props.paths;
  //Logout
  const logout = () => {
    localStorage.removeItem("authToken");
    setAnchorEl(null);
    dispatch(sktrDetailsSlice.actions.logout());
  };
  return (
    <AppBar position="static" color="transparent">
      <TabContext value={value}>
        <Toolbar>
          <IconButton
            size="large"
            edge="start"
            color="inherit"
            aria-label="logo"
            style={{ "margin-right": "10%" }}
          >
            <CatchingPokemonIcon />
          </IconButton>
          {/* <Typography variant='h6' component='div'>
            Skutr
          </Typography> */}
          <Stack direction="row" spacing={2}>
            <TabList value={value} onChange={handleChange} centered>
              {paths.map((header, indx) => {
                if (header.children.length) {
                  return <Tab label={header.title} index={indx} />;
                } else {
                  return (
                    <Tab
                      label={header.title}
                      component={NavLink}
                      exact
                      to={header.path}
                    />
                  );
                }
              })}
              {/* <Tab label="Item One" index={0} />
              <Tab label="Item Two" index={1} />
              <Tab label="Item Three" index={2} />
              <Tab label="test" component={NavLink} exact to="/test" />
               */}
            </TabList>
          </Stack>
          <div className="login_logout">
            <Button
              id="demo-customized-button"
              aria-controls={open ? "demo-customized-menu" : undefined}
              aria-haspopup="true"
              aria-expanded={open ? "true" : undefined}
              variant="contained"
              disableElevation
              onClick={handleClick}
              endIcon={<KeyboardArrowDownIcon />}
            >
              Peter Parker
            </Button>
            <StyledMenu
              id="demo-customized-menu"
              MenuListProps={{
                "aria-labelledby": "demo-customized-button",
              }}
              anchorEl={anchorEl}
              open={open}
              onClose={handleClose}
            >
              <MenuItem
                onClick={handleClose}
                disableRipple
                component={NavLink}
                exact
                to={"/profile"}
              >
                <AccountCircleIcon />
                Profile
              </MenuItem>
              <MenuItem
                onClick={handleClose}
                disableRipple
                component={NavLink}
                exact
                to={"/change_password"}
              >
                <PasswordIcon />
                Change Password
              </MenuItem>
              <Divider sx={{ my: 0.5 }} />
              <MenuItem
                disableRipple
                component={NavLink}
                onClick={logout}
                exact
                to={"/"}
              >
                <LogoutIcon />
                Logout
              </MenuItem>
            </StyledMenu>
          </div>
        </Toolbar>
        {/* style={{"display":"flex", "flex-direction": "column", alignItems:"center"}} */}
        {paths.map((header, indx) => {
          if (header.children.length) {
            return (
              <TabPanel value={indx} index={indx}>
                <Toolbar style={{ "margin-left": "10%" }}>
                  <Stack direction="row" spacing={2}>
                    <List component="nav">
                      {header.children.map((child, ind) => {
                        return (
                          <ListItem disablePadding>
                            <ListItemButton
                              component={NavLink}
                              exact
                              to={header.path + child.path}
                            >
                              <ListItemText primary={child.title} />
                            </ListItemButton>
                          </ListItem>
                        );
                      })}
                    </List>
                  </Stack>
                </Toolbar>
              </TabPanel>
            );
          }
          return null;
        })}
        {/* <TabPanel value={0} index={0}>
              <Toolbar style={{"margin-left":"10%"}} >
                <Stack direction='row' spacing={2}>
                  <List component="nav">
                    <ListItem disablePadding>
                      <ListItemButton component={NavLink} exact to="/">
                        <ListItemText primary="Home" />
                      </ListItemButton>
                    </ListItem>
                    <ListItem disablePadding>
                      <ListItemButton component={NavLink} to="/about">
                        <ListItemText primary="About" />
                      </ListItemButton>
                    </ListItem>
                  </List>
                </Stack>
            </Toolbar>
            </TabPanel> */}
        {/* <TabPanel value={1} index={1}>
              <Toolbar style={{"margin-left":"10%"}} >
                <Stack direction='row' spacing={2}>
                  <List component="nav">
                    <ListItem disablePadding>
                      <ListItemButton component={NavLink} exact to="/">
                        <ListItemText primary="Home1" />
                      </ListItemButton>
                    </ListItem>
                    <ListItem disablePadding>
                      <ListItemButton component={NavLink} to="/about">
                        <ListItemText primary="About1" />
                      </ListItemButton>
                    </ListItem>
                  </List>
                </Stack>
            </Toolbar>
            </TabPanel>
            <TabPanel value={2} index={2}>
              <Toolbar style={{"margin-left":"10%"}} >
                <Stack direction='row' spacing={2}>
                  <List component="nav">
                    <ListItem disablePadding>
                      <ListItemButton component={NavLink} exact to="/">
                        <ListItemText primary="Home2" />
                      </ListItemButton>
                    </ListItem>
                    <ListItem disablePadding>
                      <ListItemButton component={NavLink} to="/about">
                        <ListItemText primary="About2" />
                      </ListItemButton>
                    </ListItem>
                  </List>
                </Stack>
            </Toolbar>
            </TabPanel> */}
      </TabContext>
    </AppBar>
  );
}
